
import { Component, Vue } from 'vue-property-decorator'

export type QuestionAnswerType = {
  tagName?: string
  duration?: number
  inputs?: string[]
  isHandInput?: boolean
  strokeData?: { x: number; y: number }[][]
}

export interface StudyDummyBaseMethod {
  getQuestionAnswer(): QuestionAnswerType
  clearInputedElements(): void
  restoreInputedElements(): void
}

@Component
export default class StudyApis extends Vue {
  protected async studyCompleteApi(answers: QuestionAnswerType[], onSuccess: () => void, onError: () => void) {
    const headers = { 'Content-Type': 'multipart/form-data' }
    const params = new FormData()
    let blobPromises: Promise<void>[] = []
    answers.forEach((answer, index) => {
      params.append(`study[answers][${index}][duration]`, (answer.duration || 0).toString())
      const key = `study[answers][${index}][inputs][]`
      if (answer.inputs) {
        answer.inputs.forEach((input) => {
          if (index == 1 && input) {
            // 音声ファイル
            const blob = fetch(input)
              .then((response) => {
                return response.blob()
              })
              .then((blob) => {
                params.append(key, blob)
              })
              .catch(() => {
                params.append(key, '')
              })
            blobPromises.push(blob)
          } else {
            params.append(key, input)
          }
        })
      } else {
        params.append(key, '')
      }
    })
    // 音声ファイルが取得出来るまで待つ
    await Promise.all(blobPromises)

    await Vue.prototype.$http.httpWithToken
      .post('/v1/student/study/complete', params, { headers: headers })
      .then(() => {
        onSuccess()
      })
      .catch(() => {
        onError()
      })
  }
}
